import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {retry, catchError} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CepService {

  constructor( private _httpClient: HttpClient,) { }

    // Headers
    httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
    }

    getCepInformation (cep): Observable<any> {

    let url = 'https://viacep.com.br/ws/' + cep + '/json/'

    return this._httpClient.get<any>(url)
      .pipe(
        retry(2),
        catchError(this.handleError))
  }

  // Manipulação de erros
  handleError (error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Erro ocorreu no lado do client
      errorMessage = error.error.message;
    } else {
      // Erro ocorreu no lado do servidor
      errorMessage = `Código do erro: ${ error.status }, ` + `menssagem: ${ error.message }`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  };
  
}
